export default {
  init() {
    /*
     * SELECTORS
     */

      let customSelects = document.querySelectorAll('.custom-filter-select .top p');
      let toggleMobileButton = document.querySelector('.mobile-toggle-button');
      let filtersWrapper = document.querySelector('.casino-games-listing .filters');
    /*
     * EVENTS
     */

      const toggleFilterOpen = () => {
        filtersWrapper.classList.toggle('open')
      }

    /*
     * ACTIONS
     */
      customSelects.forEach((e) => {
        e.addEventListener('click', (el) => {
          customSelects.forEach((innerE) => {
            let topElement = innerE.closest('.top');
            if (topElement !== el.target.closest('.top')) {
              topElement.classList.remove('open');
            }
          });
          el.target.closest('.top').classList.toggle('open')
        })
      });
      toggleMobileButton.addEventListener('click', toggleFilterOpen);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/casinoGames.js